<template>
  <Modal
    title="请支付订单"
    :visible="visible"
    @cancel="handleCancel"
    centered
    :forceRender="true"
    :closable="false"
  >
    <template slot="footer">
      <Button key="submit" type="primary" @click="skipPayment">
        跳过支付
      </Button>
    </template>
    <div class="qrcode">
      <div id="wechat"></div>
      <span>请使用微信/支付宝扫描二维码支付</span>
    </div>
  </Modal>
</template>

<script>
import Vue from 'vue';
import { Modal, Tabs, Button } from 'ant-design-vue';
import 'ant-design-vue/es/modal/style/css';
import 'ant-design-vue/es/tabs/style/css';
import 'ant-design-vue/es/button/style/css';
import '../../util/default.css';

import qrcode from 'qrcodejs2';

Vue.use(Modal); // 一定要用use，是antd的问题。否则会报警告
export default {
  props: [
    'visible',
    'wechatLink'
  ],
  components: {
    Modal, Tabs,
    TabPane: Tabs.TabPane,
    Button
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    skipPayment() {
      // 跳转到订单页面
      this.$emit('cancelPayment')
    }
  },
  watch: {
    visible(value) {
      if (value) {
        // 产生qrcode
        new qrcode('wechat', {
          width: 150,
          height: 150,
          text: this.wechatLink
        });
      } else {
        document.getElementById('wechat').innerHTML = '';
      }
    }
  },
  mounted() {
    
  }
}
</script>

<style scoped>
.qrcode {
  height: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.qrcode span {
  margin-top: 30px;
  font-size: 16px;
}
</style>